<form name="frmLeavers"  style="margin-top:-1.5%;">
    <div class="container panel panel-default col-md-12" style="padding-left:0%;padding-right:0%;border-color:black;min-height:80vh;">
        <div class="panel panel-heading" style="background: linear-gradient(141deg, #460073 20%, #A100FF 65%);font-weight: bold; margin-top: -2.2%; color: white;">Leavers</div>
        <div class="panel-body">
            <div class="form-group row" style="margin-top:-2%;">
                <div class="col-sm-14">
                    <div class="form-group row">
                        <div class="col-sm-3 formdivcaptions">
                            <label style="color:black;font-weight:bold;margin-right:30px;">Device Type</label>&nbsp;
                            <label *ngFor="let DeviceType of DeviceTypeList">
                                <input type="radio" name="radioDeviceType" value="{{DeviceType.name}}" (change)="DeviceTypeEvent($event.target.value)"/><label>&nbsp;{{DeviceType.name}}&nbsp; </label>
                            </label>
                        </div>
                    </div>
                    <div class="form-group row" id="divSearch" [hidden]="!IsdivSearch">
                        <div class="col-sm-14">
                            <div class="col-sm-1">
                            </div>
                            <div class="col-sm-3">
                                <label>Leaver Enterprise ID</label>
                                <input type="text" class="form-control" id="txtLeaverEid" name="txtLeaverEid" [(ngModel)]="LeaverEid" />
                            </div>
                            <div class="col-sm-1">
                            </div>
                            <div class="col-sm-3">
                                <label>Country</label>
                                <select id="dlstCountry" name="dlstCountry" [(ngModel)]="selectedCountry" style="height:33px" class="form-control ">
                                    <option value="">&lt;--Select--&gt;</option>
                                    <option *ngFor="let C of Countries">{{C.Country}}</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-sm-12 formdivcaptions" style="margin-top:2%;">
                            <div align="center" id="divSubmit" [hidden]="!IsdivSubmit">
                                <button type="submit" id="btnSearch" class="btn btn-default btn-group-sm Button1" (click)="ShowData()"><span class="fa fa-search-plus" aria-hidden="true"></span> Search</button>&nbsp;
                                <button type="submit" id="searchClear" class="btn btn-default btn-group-sm Button1" (click)="clear()"><span class="fa fa-close" aria-hidden="true"></span> Clear</button>
                                <label style="width:250px"><input type='checkbox' name="checkboxname" [(ngModel)]="checked" id="check" (change)="change()" /> Do not show lapsed end date</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row table-responsive" id="divDetails" [hidden]="!IsdivDetails">
                <div style="margin-right: 20px;">
                    <table id="DeviceDetail" class="table table-bordered" border="1" style="margin-left:10%;width:80%;font-size:13px;overflow:scroll;">
                        <thead style="background: linear-gradient(to bottom,#460073 0%, #A100FF 100%); filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#2e3b46', endColorstr='#2e3b46',GradientType=0 ); ">
                            <tr>
                                <th style="display:none">S.No</th>
                                <th></th>
                                <th style="text-align: center;width:25%;">Enterprise ID</th>
                                <th style="text-align: center;">End Date</th>
                                <th style="text-align: center;">Country</th>
                            </tr>
                        </thead>
                        <tbody *ngFor="let data of successfulData.leavers">
                            <div *ngIf="getTemplate(data) == 'displayNew'; then displayBlock  else editBlock"></div>
                            <ng-template #displayBlock>
                                <tr>
                                    <td>
                                        <img src="../../../assets/img/Edit-icon.png" title="Edit" (click)="EditLeavers(data)" />
                                        <img src="../../../assets/img/Delete.png" title="Delete" (click)="DeleteLeavers(data)" />
                                    </td>
                                    <td style="display:none;">{{data.Id}}</td>
                                    <td>{{data.leaverEid}}</td>
                                    <td>{{data.endDate|date:'yyyy-MM-dd'}}</td>
                                    <td>{{data.Country}}</td>
                                </tr>
                            </ng-template>
                            <ng-template #editBlock>
                                <tr>
                                    <td>
                                        <img src="assets/img/Add.png" (click)="UpdateLeavers($event)" title="Update" />
                                        <img src="assets/img/Cancel.jpg" (click)="reset()" title="Cancel" />    
                                    </td>
                                    <td style="display:none;">{{successfulData.selected.Id}}</td>
                                    <td>
                                        <input type="text" class="form-control" [(ngModel)]="successfulData.selected.leaverEid" id="grdLeaverEid" name="grdLeaverEid" />
                                    </td>
                                    <td>
                                        <input type="text" matInput name="grdEndDate" id="grdEndDate" placeholder="yyyy-mm-dd" [(ngModel)]="successfulData.selected.endDate" style="height:30px" class="datepicker form-control" [matDatepicker]="grdEndDate" (focus)="ShowgrdEndDate()" required/>
                                        <mat-datepicker #grdEndDate></mat-datepicker>
                                    </td>
                                    <td>
                                        <select [(ngModel)]="successfulData.selected.Country" id="grdCountry" name="grdCountry" class="form-control " style="margin-bottom:2px;height:35px" required>
                                            <option value="">&lt;--Select--&gt;</option>
                                            <option *ngFor="let C of Countries">{{C.Country}}</option>
                                        </select>
                                    </td>
                                </tr>
                            </ng-template>
                        </tbody>
                        <tfoot>
                            <tr>
                                <td>
                                    <button id="btnAdd" type="button" class="btn btn-default btn-group-sm Button2" (click)="AddLeavers()">
                                        <span class="fa fa-check-circle" aria-hidden="true">
                                        </span> Add
                                    </button>
                                </td>
                                <td>
                                    <input type="text" class="form-control" [(ngModel)]="LeaverDetails.leaverEid" id="grdfleaverEid" name="grdfleaverEid" />
                                </td>
                                <td>
                                    <input type="text" matInput name="grdFEndDate" id="grdFEndDate" placeholder="yyyy-mm-dd" [(ngModel)]="LeaverDetails.endDate" [matDatepicker]="grdFEndDate"  style="height:33px" class="datepicker form-control" (focus)="ShowgrdFEndDate()" required readonly />
                                    <mat-datepicker #grdFEndDate></mat-datepicker>
                                </td>
                                <td>
                                    <select [(ngModel)]="LeaverDetails.Country" id="grdfCountry" name="grdfCountry" class="form-control " style="height:33px;margin-bottom:2px;" required>
                                        <option value="">&lt;--Select--&gt;</option>
                                        <option *ngFor="let C of Countries">{{C.Country}}</option>
                                    </select>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="4" style="text-align: center;">
                                    <!-- pager -->
                                    <ul *ngIf="pager.pages && pager.pages.length" class="pagination">
                                        <li [ngClass]="{disabled:pager.currentPage === 1}">
                                            <a (click)="setPage(1)">First</a>
                                        </li>
                                        <li [ngClass]="{disabled:pager.currentPage === 1}">
                                            <a (click)="setPage(pager.currentPage - 1)">Previous</a>
                                        </li>
                                        <li *ngFor="let page of pager.pages" [ngClass]="{active:pager.currentPage === page}">
                                            <a (click)="setPage(page)">{{page}}</a>
                                        </li>
                                        <li *ngIf="(pager.totalPages - pager.startPage) > 5 ">
                                            <a (click)="setPage(pager.startPage + 5)">...</a>
                                        </li>
                                        <li *ngIf="(pager.totalPages - pager.startPage) > 5" >
                                            <a (click)="setPage(pager.totalPages)">{{pager.totalPages}}</a>
                                        </li>
                                        
                                        <li [ngClass]="{disabled:pager.currentPage === pager.totalPages}">
                                            <a (click)="setPage(pager.currentPage + 1)">Next</a>
                                        </li>
                                        <li [ngClass]="{disabled:pager.currentPage === pager.totalPages}">
                                            <a (click)="setPage(pager.totalPages)">Last</a>
                                        </li>
                                    </ul>
                                </td>
                            </tr>
                        </tfoot>
                    </table>
                    <br />
                    
                </div>
            </div>

            <div id="AlertForAccess" [hidden]="!IsAlertForAccess">
                <div class="row" style="padding-top:-20%">
                    <div class="col-sm-12" style="margin-left:5%;">
                        <h4 style="color:red;">
                            Access Not Available.Please refer User Guidelines section for any access or tool issue.
                        </h4>
                    </div>

                </div>

            </div>
            <div id="showMsg" [hidden]="!IsshowMsg">
                <label style="color: #000000; font-weight: bold; font-size: 15px;margin-left:5%; ">{{ErrorMessage}}</label>
            </div>

        </div>
    </div>
</form>